import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type SortableColumnHeaderProps = {
  label: string
  active: boolean
  direction: 'asc' | 'desc' | null
  onToggle: () => void
}

export function SortableColumnHeader({
  label,
  active,
  direction,
  onToggle,
}: SortableColumnHeaderProps) {
  const SortIcon = active
    ? direction === 'asc'
      ? ArrowUp
      : ArrowDown
    : ArrowUpDown

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="group -ml-3 h-8 w-full justify-start gap-1 px-2 font-medium"
      onClick={(event) => {
        event.stopPropagation()
        onToggle()
      }}
      aria-label={`Sort by ${label}`}
    >
      {label}
      <SortIcon
        className={cn(
          'size-3.5 shrink-0 transition-opacity',
          active
            ? 'text-foreground opacity-100'
            : 'text-muted-foreground/70 opacity-0 group-hover:opacity-100',
        )}
        aria-hidden
      />
    </Button>
  )
}
